export default __webpack_public_path__ + "static/media/x.56e6885c.svg";